import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const SidebarLink = styled(Link)`
  display: flex;
  color: #e1e9fc;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  list-style: none;
  height: 60px;
  text-decoration: none;
  font-size: 18px;

  &:hover {
    background: #545450 ;
    border-left: 4px solid #ad9867;
    cursor: pointer;
    color: #e1e9fc;
  }

  &:active {
    color: #e1e9fc;
  }
`;

const SidebarLabel = styled.span`
  margin-left: 16px;
`;

const DropdownLink = styled(Link)`
  background: #3a3a3a;
  height: 60px;
  padding-left: 3rem;
  display: flex;
  align-items: center;
  text-decoration: none;
  color: #e1e9fc;
  font-size: 18px;

  &:hover {
    background: #545450 ;
    cursor: pointer;
    color: #e1e9fc;
    border-left: 4px solid #ad9867;
  }

  &:active {
    color: #e1e9fc;
  }
`;

const SubMenu = ({ item, showSidebar }) => {
  const [subnav, setSubnav] = useState(false);

  const showSubnav = () => setSubnav(!subnav);
  

  return (
    <React.Fragment>
      <SidebarLink to={item.path} onClick={item.subNav === undefined ? showSidebar :  item.subNav && showSubnav}>
        <div>
          {item.icon}
          <SidebarLabel>{item.title}</SidebarLabel>
        </div>
        <div>
          {item.subNav && subnav
            ? item.iconOpened
            : item.subNav
            ? item.iconClosed
            : null}
        </div>
      </SidebarLink>
      {subnav &&
        item.subNav.map((item, index) => {
          return (
            <DropdownLink to={item.path} key={index} onClick={showSidebar}>
              {item.icon}
              <SidebarLabel>{item.title}</SidebarLabel>
            </DropdownLink>
          );
        })}
    </React.Fragment>
  );
};

export default SubMenu;



// WEBPACK FOOTER //
// ./src/components/SubMenu.js